import { FC } from 'react';
import { useDropDownContext } from '../drop-down';
import { ShevronDownIcon } from '../icons';
import { ShevronStyled } from './select-shevron-action.styled';

export const SelectShevronAction: FC = () => {
  const { isOpen } = useDropDownContext();

  return (
    <ShevronStyled $isOpen={isOpen}>
      <ShevronDownIcon />
    </ShevronStyled>
  );
};
